// `video.text`: a video from a prompt (D3).
// Live's video list label (`VIDEO_GENERATION_TYPE_LABEL`).
import { VideoTextQuote, VideoTextRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";
import { commonFields, everyShotWritten, videoFields } from "./shared";

export const jobType: JobTypeModule<"video.text"> = {
  type: "video.text",
  label: "Text-to-Video",
  source: "text",
  pair: "video.image",
  fields: (draft, advanced) => ({ ...commonFields(draft), ...videoFields(draft, advanced) }),
  request: VideoTextRequest.refine(everyShotWritten),
  quote: VideoTextQuote,
};
